import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './Header.css';

const Header = () => {
    const { t } = useTranslation();
    return (
        <div className={styles.reportsHeader}>
            <div className={styles.leftContainer}>
                <div data-testid='reports-page-title' className={styles.titleText}>
                    {t('Reports')}
                </div>
            </div>
        </div>
    );
};

export default Header;
